// extracted by mini-css-extract-plugin
export default {"align-cc":"Header_align-cc__dtfZP","align-lc":"Header_align-lc__wowlo","align-rc":"Header_align-rc__n-KFk","header":"Header_header__jMcwM","search":"Header_search__hOgRI"};